




import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator'
import dataProxyService from '../services/data-proxy.service';
import { ModelVozila } from '../services/BackendProxies';

@Component({})
export default class ModelVozilaEditor extends Vue {
    modeliVozila = [];
    @Prop() value!: string;
    @Prop() markaVozilaId!: string;
    @Prop({default: false}) invalid!: boolean;

    model = '';

    @Watch("value") onValueChange(value) {
        //console.log('Value changed', value);
        if (value || value === null) {
            this.model = value;
        }
    }

    @Watch("model") onModelChange(value) {
        this.input(value);
    }

    @Emit() input(value) {
    }

    @Watch('markaVozilaId')
    async ucitaj(markaVozilaId) {
        const value = this.value;
        if (markaVozilaId) {
            const markeVozila = await dataProxyService.vratiMarkeVozila();
            const markaVozila = markeVozila.find(x => x.id == markaVozilaId);
            if (markaVozila) {
                this.modeliVozila = markaVozila.modeliVozila.map(x => ({id: x.id, text: x.naziv}));
                this.modeliVozila.unshift({id: '', text: '...'});
            }
        }
        this.model = value;
    }
}
